<script>
    import { createEventDispatcher } from 'svelte';
    import IconDel from "../icons/IconDel.svelte";
    import IconEdit from '../icons/IconEdit.svelte';
    import IconHistory from '../icons/IconHistory.svelte';
    import IconOrder from '../icons/IconOrder.svelte';
    import IconSellOff from '../icons/IconSellOff.svelte';

    export let customer = {firstName: "", lastName: "", remark: ""};

    const dispatch = createEventDispatcher();
    function customerDeleted() {
        dispatch('customerDeleted', {
            
        });
    }

    function editCustomer(editedCustomer) {
        let editedCustomerItem = editedCustomer.detail.item;
        dispatch('editCustomer', {
            editedCustomerItem
        });
    }

    function sellOffConfirmed() {
        customer.cheeseCount_OpenOrders = customer.cheeseCount_OpenOrders - 1;
        dispatch('sellOffConfirmed', {
            
        });
    }
</script>

<div class="box">

    <div class="content">{customer.firstName}&nbsp;{customer.lastName}</div>
    <textarea class="customtextarea" readonly bind:value={customer.address}/>
    <div class="contentContactData">{customer.phone}&nbsp;{customer.mobile}&nbsp;{customer.email}</div>
    <textarea class="customtextarea" readonly bind:value={customer.remark}/>

    <div class="icons">
        <IconOrder customer={customer} />
        <IconSellOff customer={customer} on:sellOffConfirmed={sellOffConfirmed} />
        <IconHistory />
        <IconEdit item={customer} on:clicked={(editedCustomer) => editCustomer(editedCustomer)}/>
        <IconDel customer={customer} on:clicked={customerDeleted}/>
    </div>
</div>

<style>
    textarea {
        background-color: transparent;
        border-color: transparent;
        cursor: default;
        pointer-events: none;
        padding: 0px;
        height: auto;
		resize: none;
		overflow: hidden;
    }

    .content {
        margin-top: 0px;
        margin-right: 40px;
        cursor: default;
    }

    .contentContactData {
        margin-top: 0px;
        margin-right: 40px;
        cursor: default;
    }

	.box {
	  background: lightgray;
	  padding: 10px;
	  border-radius: 0.8rem;
      margin-bottom: 10px;
	  display: flex;
	  flex-direction: column;
	}
    
    .icons {
        align-self: flex-end;
        display: inline-flex;
        flex-wrap: wrap;
    }

</style>